var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "cra-request-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "modal-dialog-size": "md",
    },
    on: { show: _vm.handleShow, hide: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm.noaFailure
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("noa-request.updateNoaService")) +
                      "\n    "
                  ),
                ]
              : [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("noa-request.requestFederalNoa")) +
                      "\n      "
                  ),
                  _c("span", {
                    staticClass: "pendo--badge-target pendo--badge-right",
                  }),
                ],
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.noaFailure
              ? [
                  _c("p", {
                    staticClass: "text-justify",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("noa-request.messages.craShutdown")
                      ),
                    },
                  }),
                ]
              : [
                  !_vm.noaDisabled
                    ? _c("account-usage-banner", {
                        attrs: {
                          page: _vm.accountPlanPage,
                          "position-fixed": false,
                          "side-right": false,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c("incident-message", {
                        attrs: { "service-name": "hellosign" },
                        on: { update: _vm.handleIncidentUpdate },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c("incident-message", {
                        attrs: { "service-name": "cra" },
                        on: { update: _vm.handleIncidentUpdate },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "noa-request.messages.doorrProvidesAccessToNoa"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "noa-request.messages.asLongAsClientProvideConsent"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "noa-request.messages.willAttemptToPullNote"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.IS_LOCALE_EN
                        ? _c(
                            "b-col",
                            { staticClass: "text-center", attrs: { lg: "4" } },
                            [
                              _c("div", { staticClass: "w-75 mx-auto" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://www.mrtaxes.ca/filogix-documents-1/",
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-100",
                                      attrs: {
                                        src: require("@Broker/assets/img/noa-mr-taxes.png"),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://www.mrtaxes.ca/",
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "Powered by Mr. Taxes\n              "
                                    ),
                                    _c("icon", {
                                      attrs: {
                                        name: "share-square-o",
                                        icon: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-100 pt-3" },
                    [
                      !_vm.successfulRequest
                        ? _c(
                            "form",
                            {
                              ref: "craForm",
                              attrs: { id: "cra-request-form" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "noa-request.messages.detailsBelow"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass:
                                        "material-input-static-label",
                                      attrs: {
                                        label: _vm.$tc(
                                          "documents.selectApplicant",
                                          1
                                        ),
                                      },
                                    },
                                    [
                                      _c("applicant-select", {
                                        attrs: {
                                          id: "applicant-select",
                                          multiple: false,
                                          placeholder: _vm.$tc(
                                            "documents.selectApplicant",
                                            1
                                          ),
                                          disabled: _vm.noaDisabled,
                                          "auto-select-main-applicant": "",
                                        },
                                        model: {
                                          value: _vm.selectedApplicant,
                                          callback: function ($$v) {
                                            _vm.selectedApplicant = $$v
                                          },
                                          expression: "selectedApplicant",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("agents-select", {
                                    ref: "agentsSelect",
                                    attrs: {
                                      multiple: false,
                                      value: _vm.requesterAgentOrDefault,
                                      required: "",
                                      "agent-usernames-to-include":
                                        _vm.validAgentsForNoa,
                                      disabled: _vm.noaDisabled,
                                    },
                                    on: { change: _vm.handleChange },
                                  }),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "noa-request.messages.selectedAgentNote"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          )
                        : [
                            _c("div", { staticClass: "hellosign-content" }, [
                              _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "noa-request.messages.clickContinueToSend"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c(
                                  "span",
                                  { staticClass: "bold text-danger" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "noa-request.messages.importantNote"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              ref: "iframeWrapper",
                              attrs: { id: "hellosign-iframe-wrapper" },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            !_vm.successfulRequest && !_vm.noaFailure
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: _vm.tooltipMsg,
                        expression: "tooltipMsg",
                      },
                    ],
                  },
                  [
                    !_vm.noaDisabled
                      ? _c(
                          "plan-simple-button",
                          {
                            attrs: {
                              page: _vm.accountPlanPage,
                              disabled:
                                _vm.$v.$invalid || _vm.disableRequestByPlan,
                              loading: _vm.requesting.loading,
                              "loading-succeeded": _vm.requesting.success,
                            },
                            on: { click: _vm.sendNOARequest },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("global.words.continue")) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.disableRequestByPlan
              ? _c("icon", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.top",
                      value: _vm.$t("noa-request.messages.anotherAgentIsFree"),
                      expression:
                        "$t('noa-request.messages.anotherAgentIsFree')",
                      modifiers: { top: true },
                    },
                  ],
                  staticClass: "text-danger",
                  attrs: { name: "exclamation-circle" },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }